import { ButtonTheme, ButtonV2 } from 'builder/components/Button'
import Icon24 from 'builder/components/Icon'
import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION_KEY } from '../../constants'
import { ReviewFullSection } from '../../styles'
import errorImg from './assets/error.png'
import { Image, Description, Content } from './styles'

type Props = {
  onRetry?: () => void
}

export const AiResumeReviewError = (props: Props) => {
  const { onRetry } = props
  const { i18n } = useI18n()

  return (
    <ReviewFullSection data-testid="ai-resume-review-error">
      <Image src={errorImg} alt="Error banner image" />
      <Content>
        <Description>{i18n.t(`${TRANSLATION_KEY}.error.description`)}</Description>
        {!!onRetry && (
          <ButtonV2
            size="small"
            theme={ButtonTheme.ghost}
            leadingIcon={<Icon24.TurnLeftRegular />}
            onClick={onRetry}
          >
            {i18n.t(`${TRANSLATION_KEY}.error.retry`)}
          </ButtonV2>
        )}
      </Content>
    </ReviewFullSection>
  )
}
